import React, { useState, useEffect, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Grid, Typography, Box, Container } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";

import { getSummaryTime } from "../../../../actions/summary-time";
import ButtonBlue from "../../shared/general/ButtonBlue";
import DatePickerCustom from "../../shared/date/datePicker";
import loading from "../../assets/social-media.gif";

import TableEmployee from "./table";

const StyledRoot = styled("div")({
  backgroundColor: "#FFFFFF !important",
  "& .MuiContainer-root": { paddingBottom: 16 },
});

const StyledBoxSearch = styled(Box)({
  marginTop: 22,
  "& .label": { fontWeight: 600, fontSize: 14, marginTop: 16, marginBottom: 8 },
  "& .wrap-search-action": { marginTop: 50, display: "flex", justifyContent: "flex-start" },
});

const StyledLoading = styled("div")({
  display: "flex", justifyContent: "center", alignItems: "center", height: "inherit",
});

const SummaryTimePage = () => {
  const dispatch = useDispatch();
  const today = dayjs().toDate();
  const { t } = useTranslation();

  const summaryTimeCompanyState = useSelector((state) => state.summaryTimeCompany);
  const summaryTimeListIsFetching = summaryTimeCompanyState && summaryTimeCompanyState.isFetching ? summaryTimeCompanyState.isFetching : false;

  const [search, setSearch] = useState({
    start: dayjs(today).set("date", 1),
    end: dayjs(today).set("date", dayjs(today).daysInMonth()),
  });

  function getDatePayload(){
    return {
      start: dayjs(search.start).format("YYYY-MM-DD"),
      end: dayjs(search.end).format("YYYY-MM-DD"),
    };
  }

  useEffect(function(){
    var payload = getDatePayload();
    dispatch(getSummaryTime(payload, {}));
  }, []);

  const handleClickSearch = () => {
    var payload = getDatePayload();
    dispatch(getSummaryTime(payload, {}));
  };

  return (
    <StyledRoot className="page">
      <Container maxWidth="lg">
        <Typography variant="h4" style={{ paddingTop: 8 }}>
          {t("SummaryOTandShift")}
        </Typography>

        <div style={{ marginBottom: 16 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={3}>
              <StyledBoxSearch>
                <Typography className="label" color="text.third">{t("StartDate")}</Typography>
                <div className="search-date">
                  <DatePickerCustom
                    minDate={dayjs().subtract(4, "year")}
                    maxDate={dayjs()}
                    inputFormat="D MMM YYYY"
                    value={search.start}
                    name="start"
                    onChange={function(newValue){ setSearch({ start: newValue, end: search.end }); }}
                  />
                </div>
              </StyledBoxSearch>
            </Grid>

            <Grid item xs={3}>
              <StyledBoxSearch>
                <Typography className="label" color="text.third">{t("EndDate")}</Typography>
                <div className="search-date">
                  <DatePickerCustom
                    minDate={dayjs(search.start)}
                    maxDate={dayjs()}
                    inputFormat="D MMM YYYY"
                    value={search.end}
                    name="end"
                    onChange={function(newValue){ setSearch({ start: search.start, end: newValue }); }}
                  />
                </div>
              </StyledBoxSearch>
            </Grid>

            <Grid item xs={3}>
              <StyledBoxSearch>
                <div className="wrap-search-action">
                  <ButtonBlue startIcon={<SearchRoundedIcon />} variant="contained" onClick={handleClickSearch}>
                    {t("Search")}
                  </ButtonBlue>
                </div>
              </StyledBoxSearch>
            </Grid>
          </Grid>
        </div>

        {summaryTimeListIsFetching ? (
          <StyledLoading><img width="80" alt="loading" src={loading} /></StyledLoading>
        ) : (
          <Fragment>
            <TableEmployee />
          </Fragment>
        )}
      </Container>
    </StyledRoot>
  );
};

export default SummaryTimePage;
